<template>
<footer class="footer">
<van-tabbar v-model="active" fixed active-color="#f44">
  <van-tabbar-item to="/">
    <template #icon="props">
      <img src="../assets/images/nav/taobao.png"/>
    </template>
    淘宝
  </van-tabbar-item>
  <van-tabbar-item to="/jd">
    <template #icon="props">
      <img src="../assets/images/nav/jd.jpg"/>
    </template>
    京东</van-tabbar-item>
  <van-tabbar-item to="/pdd">
    <template #icon="props">
      <img src="../assets/images/nav/pdd.jpg"/>
    </template>
    拼多多</van-tabbar-item>
  <van-tabbar-item to="/user" icon="friends-o">我的</van-tabbar-item>
</van-tabbar>
</footer>
</template>

<script>
export default {
  data () {
    return {
      active:0,
    }
  },
  created(){
      switch (this.$route.path){
        case '/':
            this.active = 0
            break;
        case '/jd':
          this.active = 1
          break;
        case '/pdd':
          this.active = 2
          break;
        case '/user':
          this.active = 3
          break;
        default:
          this.active = 0
            break;
      }
  },
  methods:{
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" type="text/less" scoped>
 .footer{
   height: 51px;
 }
</style>



// WEBPACK FOOTER //
// src/components/vfooter.vue